import forList from '@/mixin/forList';
import ViewParams from './ViewParams.vue';

export default {
    name: 'Logs',
    mixins: [forList],
    components: { ViewParams },

    data() {
        return {
            SP_: {
                searchValue: '', // 账号
                searchStartTime: '', // 开始时间
                searchEndTime: '', // 结束时间
                searchModel:''
            },

            detailData: null,
            detailTitle: '输入参数',
            pickerOptions: {
                disabledDate: this.calculateDisabledDate,
            },
        };
    },

    methods: {
        calculateDisabledDate(time) {
            // 计算半年前的日期（当前日期 - 6个月）
            const halfYearAgo = new Date();

            halfYearAgo.setMonth(halfYearAgo.getMonth() - 6);

            // 禁用半年前的日期（注意：time 参数是当前遍历的日期）
            return time.getTime() < this.resetTime(halfYearAgo).getTime();
        },
        // 重置时间为当天的 00:00:00（确保日期比较准确）
        resetTime(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        },
        async fetchData() {
            const loading = this.$loading();

            try {
                const data = {
                    ...{
                        // 参数不足会报错，，
                        searchValue: '', // 搜索类容
                        searchStartTime: '', // 开始时间
                        searchEndTime: '', // 结束时间
                        searchModel:''
                    },
                    ...this.extractParams(),
                };

                // this.fetchCount(data);
                const res = await this.$axios({
                    url: '/api/operLogs/getlist',
                    method: 'post',
                    data,
                });
                if (res.code === 2000) {
                    if (res.data.operList.length < this.SP.pageSize) {
                        this.total = this.SP.pageSize * this.SP.pageNum;
                    } else {
                        this.total = this.SP.pageSize * this.SP.pageNum + res.data.operList.length;
                    }

                    const list = res.data.operList.map(item => {
                        if (item.in_param?.length > 20) {
                            item.short_in_param = item.in_param.slice(0, 30) + '...';
                        }
                        if (item.out_param?.length > 20) {
                            item.short_out_param = item.out_param.slice(0, 30) + '...';
                        }
                        return item;
                    });
                    this.tableData = list;
                    loading.close();
                } else if (res.code !== 1003) throw res;
            } catch (reason) {
                console.warn('获取数据失败', reason);
                this.$message({
                    message: reason.msg || '获取数据失败',
                    type: 'warning',
                });

                loading.close();
            }
        },

        async fetchCount(data) {
            try {
                const res = await this.$axios({
                    url: '/api/operLogs/getlistCount',
                    method: 'post',
                    data,
                });
                if (res.code === 2000) {
                    this.total = res.data.count;
                } else if (res.code !== 1003) throw res;
            } catch (reason) {
                console.warn('获取数量失败', reason);
            }
        },

        // 查看详细参数
        handleInParam(index) {
            this.detailTitle = '输入参数';
            const item = this.tableData[index];
            this.detailData = item.in_param;
        },
        handleOutParam(index) {
            this.detailTitle = '输出参数';
            const item = this.tableData[index];
            this.detailData = item.out_param;
        },
    },
};
